import React from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { changePassword } from "../actions/Auth";

const passwordPattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
const blank = { passwordCurrent: "", password: "", passwordConfirm: "" };

export default function ChangePassword() {
  const dispatch = useDispatch();
  const [form, setForm] = React.useState(blank);
  const [show, setShow] = React.useState(false);
  const [error, setError] = React.useState("");
  const [saving, setSaving] = React.useState(false);
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  async function sendData(e) {
    e.preventDefault();
    if (!form.passwordCurrent || !form.password || !form.passwordConfirm) {
      return setError("Please fill in all three fields.");
    }
    if (form.password !== form.passwordConfirm) {
      return setError("The new passwords do not match.");
    }
    if (!passwordPattern.test(form.password)) {
      return setError(
        "Use at least 8 characters with an uppercase letter, a lowercase letter, a number and a symbol."
      );
    }
    setError("");
    setSaving(true);
    const changed = await dispatch(changePassword(form));
    setSaving(false);
    if (changed) setForm(blank);
  }

  const eye = (
    <InputAdornment position="end">
      <IconButton size="small" onClick={() => setShow(!show)} aria-label={show ? "Hide passwords" : "Show passwords"}>
        {show ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <Stack component="form" onSubmit={sendData} gap={2} sx={{ maxWidth: 420 }}>
      <TextField
        label="Current password"
        type={show ? "text" : "password"}
        autoComplete="current-password"
        value={form.passwordCurrent}
        onChange={set("passwordCurrent")}
        InputProps={{ endAdornment: eye }}
      />
      <TextField
        label="New password"
        type={show ? "text" : "password"}
        autoComplete="new-password"
        value={form.password}
        onChange={set("password")}
        helperText="At least 8 characters, with upper and lower case, a number and a symbol"
      />
      <TextField
        label="Confirm new password"
        type={show ? "text" : "password"}
        autoComplete="new-password"
        value={form.passwordConfirm}
        onChange={set("passwordConfirm")}
        error={Boolean(form.passwordConfirm) && form.password !== form.passwordConfirm}
      />
      {error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}
      <div>
        <Button type="submit" variant="contained" disabled={saving}>
          {saving ? "Changing..." : "Change password"}
        </Button>
      </div>
    </Stack>
  );
}
